import { types } from "../Actions/types";

const initialState = {
  badgelist: [],
  error: null,
  badgeSingle: "",
  popupmodel: "",
  badgeuserlist: [],
};

const Badge = (state = initialState, action) => {
  let { type, payload, error } = action;
  if (payload && payload.error !== null) {
    error = payload.error;
  }

  switch (type) {
    case types.BADGE_LIST:
      return {
        ...state,
        badgelist: payload,
        error,
      };
    case types.BADGE_SINGLE:
      return {
        ...state,
        badgeSingle: payload,
        error,
      };
    case types.BADGE_USER_LIST:
      return {
        ...state,
        badgeuserlist: payload,
        error,
      };
    case types.BADGE_FORM_MODEL:
      return {
        ...state,
        popupmodel: payload,
      };

    default:
      return state;
  }
};

export default Badge;
